// Import the functions you need from the SDKs you need
import { initializeApp, getApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const environment = import.meta.env.VITE_ENVIRONMENT || "development";

let firebaseConfig;
if (environment === "development" || environment === "dev") {
  firebaseConfig = {
    apiKey: "AIzaSyBLMWIllGgK7uN5anxzYNNz3j2LSQ2-UnU",
    authDomain: "dashpet-dev.firebaseapp.com",
    projectId: "dashpet-dev",
    storageBucket: "dashpet-dev.firebasestorage.app",
    messagingSenderId: "905499851568",
    appId: "1:905499851568:web:b95e33c5c764faf5eae6f5",
  };
} else if (environment === "production") {
  firebaseConfig = {
    apiKey: "AIzaSyBvaASHtXo6P-nB2SPMPC0SRWdMi7E8_2E",
    authDomain: "dashpet-prod.firebaseapp.com",
    projectId: "dashpet-prod",
    storageBucket: "dashpet-prod.firebasestorage.app",
    messagingSenderId: "945343676278",
    appId: "1:945343676278:web:6449005437c4a5840a8457",
  };
} else if (environment === "staging") {
  firebaseConfig = {
    apiKey: "AIzaSyAFNWNJYHh7T_xwbFutSU3f3RgbiaJU_eg",
    authDomain: "dashpet-stg.firebaseapp.com",
    projectId: "dashpet-stg",
    storageBucket: "dashpet-stg.firebasestorage.app",
    messagingSenderId: "339421597844",
    appId: "1:339421597844:web:97a9d458964d1e84f12481",
  };
} else if (environment === "prototype") {
  // The client-facing prototype signs in against its own project. The deploy
  // job supplies the web-app values from repo variables.
  firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: "dashone-prototype.firebaseapp.com",
    projectId: "dashone-prototype",
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  };
}

// Firebase Storage bucket for the active env — used to build public asset URLs
// for export-style logos/covers.
export const STORAGE_BUCKET = firebaseConfig.storageBucket;

// Initialize Firebase, or adopt the app the host already created.
//
// This module is not only loaded by apps/web: apps/admin renders product
// components (the workflow config cards), and importing one pulls this file in
// alongside admin's own bootstrap. A second unconditional initializeApp for
// '[DEFAULT]' throws `app/duplicate-app` — and because the cards are lazy, the
// throw lands mid-render, which is how selecting a report type in the admin
// schedule wizard tore the surface down.
//
// Both apps point at the same dashpet project per environment, so adopting the
// existing app is the correct instance, not a fallback. Standalone apps/web is
// unaffected: no app exists yet, so this still initializes from firebaseConfig.
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
